module.exports = {
	"id": "BH",
	"name": "Bahrain",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.009486,
			"12": null,
			"13": 0.006324,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.006324,
			"19": 0.003162,
			"20": 0.006324,
			"21": 0.003162,
			"22": 0.01581,
			"23": 0.003162,
			"24": 0.012648,
			"25": null,
			"26": 0.009486,
			"27": 0.022134,
			"28": 0.012648,
			"29": 0.01581,
			"30": 0.012648,
			"31": 0.082212,
			"32": 0.01581,
			"33": 0.044268,
			"34": 0.022134,
			"35": 0.012648,
			"36": 0.03162,
			"37": 0.012648,
			"38": 0.028458,
			"39": 0.03162,
			"40": 0.012648,
			"41": 0.053754,
			"42": 0.012648,
			"43": 0.151776,
			"44": 0.025296,
			"45": 0.028458,
			"46": 0.01581,
			"47": 0.037944,
			"48": 0.06324,
			"49": 0.850578,
			"50": 0.072726,
			"51": 0.338334,
			"52": 0.303552,
			"53": 11.674104,
			"54": 3.4782,
			"55": 0.11067,
			"56": 0.037944,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.009486,
			"4": 0.003162,
			"5": null,
			"6": 0.006324,
			"7": null,
			"8": null,
			"9": 0.003162,
			"10": 0.003162,
			"11": 0.006324,
			"12": null,
			"13": null,
			"14": 0.006324,
			"15": 0.006324,
			"16": null,
			"17": null,
			"18": 0.006324,
			"19": null,
			"20": null,
			"21": 0.009486,
			"22": 0.006324,
			"23": null,
			"24": null,
			"25": 0.006324,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.006324,
			"30": null,
			"31": 0.003162,
			"32": null,
			"33": 0.012648,
			"34": 0.012648,
			"35": null,
			"36": 0.009486,
			"37": 0.018972,
			"38": 0.018972,
			"39": 0.01581,
			"40": 0.01581,
			"41": 0.006324,
			"42": 0.01581,
			"43": 0.04743,
			"44": 0.01581,
			"45": 0.044268,
			"46": 0.034782,
			"47": 0.26877,
			"48": 0.309876,
			"49": 1.966764,
			"50": 0.088536,
			"51": 0.003162,
			"52": null,
			"3.5": null,
			"3.6": 0.018972
		},
		"opera": {
			"9": null,
			"11": null,
			"12": 0.003162,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.01581,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": 0.006324,
			"35": 0.012648,
			"36": 0.012648,
			"37": 0.072726,
			"38": 0.037944,
			"39": 0.01581,
			"40": 0.192882,
			"41": 0.025296,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": 0.003162,
			"11.5": null,
			"11.6": null,
			"12.1": 0.018972
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.01581,
			"6": 0.009486,
			"7": 0.082212,
			"8": 0.1581,
			"9": 0.240312,
			"10": 0.999192,
			"3.1": null,
			"3.2": null,
			"5.1": 0.072726,
			"6.1": 0.028458,
			"7.1": null,
			"9.1": 0.69564
		},
		"ios_saf": {
			"8": 0,
			"10": 6.88077023813,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.185428796003,
			"8.1-8.4": 0.342571843464,
			"9.0-9.2": 0.163428769359,
			"9.3": 2.49333635304
		},
		"android": {
			"3": 0,
			"4": 0.0672845064599,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00841056330749,
			"4.1": 0.242704826873,
			"4.2-4.3": 0.606762067183,
			"4.4": 1.39134747287,
			"4.4.3-4.4.4": 1.40336256331
		},
		"ie": {
			"6": 0.0126557263286,
			"7": 0.00949179474649,
			"8": 0.762507511301,
			"9": 0.363852131949,
			"10": 0.215147347587,
			"11": 3.81570148809,
			"5.5": null
		},
		"op_mob": {
			"0": 0.224937252988,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00624825702744
		},
		"edge": {
			"12": 0.09486,
			"13": 0.34782,
			"14": 0.607104
		},
		"ie_mob": {
			"10": 0.0498885070423,
			"11": 0.203117492958
		},
		"bb": {
			"7": 0.0188045,
			"10": null
		},
		"samsung": {
			"0": 6.46191
		},
		"and_uc": {
			"0": 15.467556
		},
		"op_mini": {
			"0": 3.03054048998
		},
		"and_chr": {
			"0": 29.559058
		},
		"and_ff": {
			"0": 0.013676
		}
	},
	"total": 98.4648945
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/BH.json
 ** module id = 477
 ** module chunks = 0
 **/